export function parseTaxValue(val) {
  if (typeof val === 'number') return val;
  if (typeof val !== 'string') return 0;

  // Remove moedas, espaços e símbolos
  let clean = val.replace(/[^\d,.-]/g, '').replace(/\s+/g, '');

  // Se vier no formato "1.234,56" (brasileiro), troca vírgula por ponto e remove pontos de milhar
  if (clean.match(/,\d{2}$/)) {
    clean = clean.replace(/\./g, '').replace(',', '.');
  }

  // Se vier no formato "1,234.56" (americano), remove vírgulas de milhar
  if (clean.match(/\.\d{2}$/)) {
    clean = clean.replace(/,/g, '');
  }

  const num = Number(clean);
  return isNaN(num) ? 0 : num;
}


